import React, { useEffect, useState, useRef, useImperativeHandle, useMemo, forwardRef, useCallback } from 'react';

import { unpack, pack } from 'msgpackr';
import stringify from '../utils/stableStringify';
import AntPopup from './AntPopup';
import AntBaseForm from './AntBaseForm';
import AntConfig from '../utils/AntConfig';
// import AntAuth from '../utils/AntAuth';
import AntCondition from '../utils/AntCondition';
import AntLocalization from '../utils/AntLocalization';

import { AntGlobal, AntSession } from '../utils/AntContext';

export default forwardRef(function (props, ref) {
    const appGlobal = AntGlobal();
    // const session = AntSession();

    const tableName = props.table ? props.table : props.API ? props.API.entityName : '';
    const entityName = props.API && props.API.entityName ? props.API.entityName : '';
    const entityDisplay = props.API && props.API.entityDisplay ? props.API.entityDisplay : props.entityDisplay ? props.entityDisplay : '';
    const popupTitle = props.title
        ? AntLocalization.translateText(props.title)
        : `${AntLocalization.translateText({ vi: 'Tạo mới', en: 'Create', fr: 'Créer', es: 'Crear', id: 'Buat', ja: '作成', zh: '创建', ko: '생성', hi: 'बनाएं', ar: 'إنشاء' })} ${AntLocalization.translateText(entityDisplay)}`;

    const config = useMemo(() => {
        let found = appGlobal.tableConfigs?.find((t) => t.tableName === tableName);
        if (found) return found.config;

        let cnf = new AntConfig(appGlobal, tableName);
        cnf.configFields(props.fields);

        if (appGlobal.tableConfigs instanceof Array === false) appGlobal.tableConfigs = [];

        appGlobal.tableConfigs.push({
            tableName: tableName,
            config: cnf
        });
        return cnf;
    }, []);

    const popup = useRef();
    const form = useRef();

    const [mainError, setMainError] = useState({ error: null });
    const [mainData, setMainData] = useState({});

    const [shouldRender, setShouldRender] = useState(1);

    const forceRender = useCallback(() => {
        setShouldRender((v) => v + 1);
    }, []);

    const onCustomMainData = useCallback((data, changeData, overide) => {
        if (overide) {
            if (data && typeof data === 'object') {
                let newObj = JSON.parse(stringify(changeData));

                let keys = Object.keys(data);
                for (let i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    delete data[key];
                }

                return Object.assign(data, newObj);
            } else return changeData;
        }

        return Object.assign(data, changeData);
    }, []);

    const forceRenderWithData = useCallback(
        (data, overide) => {
            setMainData((v) => onCustomMainData(v, data, overide));
            // setShouldRender((v) => v + 1);
        },
        [onCustomMainData]
    );

    const initPopupError = useCallback(() => {
        if (mainError.error)
            return {
                text: mainError.error.text,
                values: mainError.error.values
            };
        return null;
    }, [mainError]);

    const popupError = useMemo(() => initPopupError(), [initPopupError]);

    const initButtons = useCallback(() => {
        return [
            {
                id: 'btnSave',
                type: 'button',
                icon: 'save',
                text: AntLocalization.translateText(props.buttonActionText ? props.buttonActionText : { vi: 'Tạo', en: 'Create', fr: 'Créer', es: 'Crear', id: 'Buat', ja: '作成', zh: '创建', ko: '생성', hi: 'बनाएं', ar: 'إنشاء' }),
                waiting_text: AntLocalization.translateText({ vi: 'Chờ xử lý', en: 'Processing', fr: 'Traitement', es: 'Procesando', id: 'Memproses', ja: '処理中', zh: '处理中', ko: '처리 중', hi: 'प्रसंस्करण', ar: 'جاري المعالجة' }),

                width: 130
            }
        ];
    }, [props.buttonActionText]);

    const popupButtons = useMemo(() => initButtons(), [initButtons]);

    const initSize = useCallback(() => {
        var formColCount = AntCondition.getValue(mainData, props.colCount);
        if (formColCount === undefined) formColCount = props.colCountDefault ? props.colCountDefault : 1;

        var formItems = props.items instanceof Array ? props.items : [];
        formItems = JSON.parse(stringify(formItems));
        formItems = formItems.filter((item) => {
            return AntCondition.isVisible(mainData, item);
        });

        var sumSpan = formItems.reduce((total, current) => {
            var colSpan = AntCondition.getValue(mainData, current.colSpan);
            if (colSpan === undefined) colSpan = current.colSpanDefault;

            return total + (colSpan !== undefined ? parseInt(colSpan) : 1);
        }, 0);

        var formLineCount = Math.ceil(sumSpan / formColCount);
        let formHeight = 0;
        if (formLineCount > 0) {
            formHeight = formLineCount * 36 + (formLineCount - 1) * 10;
            formHeight += formItems.reduce((total, current) => {
                return (
                    total +
                    (current.editorType === 'textArea' && current.options && current.options.height > 36 ? parseInt(current.options.height) - 36 : 0)
                );
            }, 0);
        }

        var minHeight;
        if (props.height instanceof Array) {
            for (let i = 0; i < props.height.length; i++) {
                const e = props.height[i];
                if (e && typeof e.when === 'object' && e.when !== null && e.value !== undefined) {
                    var isValid = AntCondition.isValid(mainData, {
                        when: e.when,
                        whenType: e.whenType
                    });
                    if (isValid) {
                        minHeight = parseFloat(e.value);
                        break;
                    }
                }
            }
        } else if (typeof props.height === 'number') minHeight = parseFloat(props.height);

        var height = 0;
        height += formHeight ? parseFloat(formHeight) : 0;
        height += 10 + 46 + 20 + 47;
        height += 10;

        if (minHeight && height < minHeight) height = minHeight;

        if (popupError) height += 20;

        var width = AntCondition.getValue(mainData, props.width);
        if (width === undefined) width = props.widthDefault;
        if (width === undefined) width = 700;

        return { width: width, height: height, minHeight: props.minHeight ? props.minHeight : minHeight, maxHeight: props.maxHeight };
    }, [
        mainData,
        props.colCount,
        props.colCountDefault,
        props.items,
        props.height,
        props.width,
        props.widthDefault,
        props.minHeight,
        props.maxHeight
    ]);

    const popupSize = useMemo(() => initSize(), [initSize]);

    const show = useCallback(
        async (objDefault, objOverideDefault) => {
            if (!popup.current) return;

            let obj = { ...objDefault };

            Object.keys(obj).forEach((k) => {
                if (obj[k] === undefined) delete obj[k];
            });

            var preparedObj = null;
            if (props.prepare !== false && props.API && props.API.postCreatePrepare) {
                preparedObj = await props.API.postCreatePrepare(obj, props.prepareConditions);
            }

            if (preparedObj) {
                // preparedObj = { ...preparedObj, ...obj };

                if (props.copyFromParentFields instanceof Array) {
                    props.copyFromParentFields.forEach((field) => {
                        if (typeof field === 'object') {
                            var parentField = field.field;
                            var aliasField = field.alias ? field.alias : field.field;

                            if (obj && obj[parentField] !== undefined && obj[parentField] !== null) {
                                if (field.when && typeof field.when === 'object') {
                                    var isValid = AntCondition.isValid(obj, {
                                        when: field.when,
                                        whenType: field.whenType
                                    });
                                    if (!isValid) return;
                                }
                                preparedObj[aliasField] = obj[parentField];
                            }
                        } else if (obj && obj[field] !== undefined && obj[field] !== null) preparedObj[field] = obj[field];
                    });
                }

                if (objOverideDefault) preparedObj = { ...preparedObj, ...objOverideDefault };

                if (props.onPrepared) await props.onPrepared(preparedObj);
                forceRenderWithData(preparedObj, true);

                popup.current.show();

                return;
            }
        },
        [props.prepare, props.API, props.prepareConditions, props.copyFromParentFields, props.onPrepared, forceRenderWithData]
    );

    const onFormError = useCallback(
        async (content, errors) => {
            if (!content && (popupError === null || popupError === undefined)) return;
            if (errors == 'TypeError: Failed to fetch') errors = { vi: 'Không thể kết nối đến hệ thống !', en: 'Can not connect to system !', fr: 'Impossible de se connecter au système !', es: '¡No se puede conectar al sistema!', id: 'Tidak dapat terhubung ke sistem!', ja: 'システムに接続できません！', zh: '无法连接到系统！', ko: '시스템에 연결할 수 없습니다!', hi: 'सिस्टम से कनेक्ट नहीं हो सकता!', ar: 'لا يمكن الاتصال بالنظام!' };
            var values = errors === undefined || errors === null ? [] : errors instanceof Array ? errors : [errors];

            content = values.length === 1 ? values[0] : content;

            setMainError({
                error: content
                    ? {
                          text: String(content),
                          values: values
                      }
                    : null
            });
        },
        [popupError]
    );

    const onFieldDataChanged = useCallback(
        async (e, newData) => {
            if (props.onFieldDataChanged) {
                var isValid = await props.onFieldDataChanged(e);
                if (!isValid) return;
            }

            forceRenderWithData(newData);
        },
        [props.onFieldDataChanged, forceRenderWithData]
    );

    const onAction = useCallback(
        async (button) => {
            if (!form.current) return false;

            if (form.current.validate) {
                var isValid = await form.current.validate();
                if (!isValid) return false;
            }

            var close = false;
            if (form.current.onAction) close = await form.current.onAction(button);

            // if (!close && props.onAction) close = await props.onAction(button);

            return close;
        },
        [props.onAction]
    );

    useImperativeHandle(ref, () => ({
        show: show
    }));

    useEffect(() => {
        if (props.onError) props.onError(content, errors);
    }, [popupError]);

    // useEffect(() => {
    //     return () => {
    //         delete popup.current;
    //         delete form.current;

    //         popup.current = null;
    //         form.current = null;
    //     };
    // }, []);

    return (
        <React.Fragment>
            {shouldRender && (
                <AntPopup
                    ref={popup}
                    isGray={true}
                    shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                    deferRendering={true}
                    height={props.height ? props.height : popupSize.height}
                    width={popupSize.width}
                    minHeight={popupSize.minHeight}
                    // maxHeight={popupSize.maxHeight}
                    autoHeight={true}
                    autoWidth={true}
                    title={popupTitle}
                    onAction={onAction}
                    name={`ant-object-creation-error-${entityName}`}
                    errors={popupError ? popupError.values : undefined}
                    errorText={AntLocalization.translateText(popupError ? popupError.text : undefined)}
                    hideOnOutsideClick={props.hideOnOutsideClick !== undefined ? props.hideOnOutsideClick : true}
                    widgets={popupButtons}
                >
                    <AntBaseForm
                        ref={form}
                        shouldRender={shouldRender + (props.shouldRender ? props.shouldRender : 1)}
                        API={props.API}
                        type={'Custom'}
                        table={props.table}
                        formData={mainData}
                        default={props.default}
                        parentData={{ ...props.parentData, ...mainData }}
                        parentFK={props.parentFK}
                        copyFromParentFields={props.copyFromParentFields}
                        alignItemLabelsInAllGroups={props.alignItemLabelsInAllGroups}
                        labelLocation={props.labelLocation}
                        colCount={props.colCount ? props.colCount : 1}
                        colCountDefault={props ? props.colCountDefault : undefined}
                        onFieldDataChanged={onFieldDataChanged}
                        validationURL={props.validationURL}
                        actionURL={props.actionURL}
                        onValidation={props.onValidation}
                        onSaving={props.onBeforeProcess}
                        onProcess={props.onProcess}
                        onSaved={props.onAfterProcess}
                        fields={props.fields}
                        items={props.items}
                        postFields={props.postFields instanceof Array ? props.postFields : undefined}
                        onError={onFormError}
                    />
                </AntPopup>
            )}
        </React.Fragment>
    );
});
